/**
 * This deployment's own values, out of the build environment.
 *
 * There is one file, not one per configuration: the addresses differ for every product and every
 * environment, so they are not in version control at all. See `scripts/with-env.mjs`, which is
 * what puts them here, and `.env.example`, which lists them.
 */
export const environment = {
    /** True only in a local build. It is the only thing that lets credentials travel without TLS. */
    local: import.meta.env.PUBLIC_LOCAL === "true",
    apiUrl: import.meta.env.PUBLIC_API_URL,
    /** Empty when nothing embeds this application, which is the usual case for it. */
    allowedHostOrigins: import.meta.env.PUBLIC_ALLOWED_HOST_ORIGINS.split(",")
        .map((origin) => origin.trim())
        .filter((origin) => origin !== ""),
};
